var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import styled from 'styled-components';
import Modal from '../../TabletsControlPage/Modals/addTabletModal';
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");
var PDFViewerModal = function (_a) {
    var show = _a.show, handleClose = _a.handleClose, fileUrl = _a.fileUrl;
    var _b = useState(null), numPages = _b[0], setNumPages = _b[1];
    var _c = useState(1), pageNumber = _c[0], setPageNumber = _c[1];
    var onDocumentLoadSuccess = function (_a) {
        var numPages = _a.numPages;
        setNumPages(numPages);
        setPageNumber(1);
    };
    var goToPrevPage = function () { return setPageNumber(pageNumber - 1); };
    var goToNextPage = function () { return setPageNumber(pageNumber + 1); };
    return (_jsx(Modal, __assign({ show: show, handleClose: handleClose }, { children: _jsxs(ModalContent, { children: [_jsx(Document, __assign({ file: fileUrl, onLoadSuccess: onDocumentLoadSuccess }, { children: _jsx(Page, { pageNumber: pageNumber }) })), _jsxs(Controls, { children: [_jsx("button", __assign({ disabled: pageNumber <= 1, onClick: goToPrevPage }, { children: "Previous" })), _jsxs("span", { children: ["Page ", pageNumber, " of ", numPages] }), _jsx("button", __assign({ disabled: pageNumber >= (numPages || 1), onClick: goToNextPage }, { children: "Next" }))] })] }) })));
};
var ModalContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n"])));
var Controls = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n\n    button {\n        background-color: #007bff;\n        color: white;\n        border: none;\n        padding: 10px;\n        cursor: pointer;\n    }\n\n    span {\n        align-self: center;\n    }\n"], ["\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n\n    button {\n        background-color: #007bff;\n        color: white;\n        border: none;\n        padding: 10px;\n        cursor: pointer;\n    }\n\n    span {\n        align-self: center;\n    }\n"])));
export default PDFViewerModal;
var templateObject_1, templateObject_2;
